import React, { useState } from "react";
import { AccordionPropTypes } from "./types";
import { ChevronDown } from "react-feather";
import { useSpring, animated, config } from "@react-spring/web";
import useMeasure from "react-use-measure";

const Accordion = ({ title = "", children, headerComponent }) => {
    const [open, setOpen] = useState(false);
    const [ref, { height: bodyHeight }] = useMeasure();
    const animation = useSpring({
        opacity: open ? 1 : 0.5,
        maxHeight: open ? bodyHeight : 0,
        config: { ...config.stiff, duration: 300 },
    });

    const toggle = () => setOpen(!open);

    return (
        <div
            className={`accordion ${open ? "open" : ""}`}
            aria-controls="accordion"
        >
            <div className="accordion__header" onClick={toggle}>
                {headerComponent ? headerComponent : <span>{title}</span>}
                <ChevronDown size={24} className={open ? "open" : ""} />
            </div>
            {open && (
                <animated.div style={animation}>
                    <div ref={ref} className="accordion__body">
                        {children}
                    </div>
                </animated.div>
            )}
        </div>
    );
};

Accordion.propTypes = AccordionPropTypes;
Accordion.defaultProps = {
    title: "Accordion",
};
export default Accordion;
